import { Component, Inject, Injector, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConfirmationDialogService } from 'src/app/services/shared/confirmation-dialog/confirmation-dialog.service';
import { NotificationService } from 'src/app/services/shared/notification/notification.service';

@Component({
    selector: 'app-modal-dominio-subdominio',
    templateUrl: './modal-dominio-subdominio.component.html',
    styleUrl: './modal-dominio-subdominio.component.scss',
    standalone: false
})
export class ModalDominioSubdominioComponent implements OnInit {
  dominio: any = "";
  subdominio: any = "";
  btnStatus: boolean = false;
  bofuenteSeleccionada: boolean = false;
  private notificationService: NotificationService;
  private confirmationDialogService: ConfirmationDialogService;

  constructor(
    injector: Injector,
    public dialogRef: MatDialogRef<ModalDominioSubdominioComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.notificationService = injector.get<NotificationService>(NotificationService);
    this.confirmationDialogService = injector.get<ConfirmationDialogService>(ConfirmationDialogService);
  }

  ngOnInit(): void {
    //cambio ahv
    this.bofuenteSeleccionada = false;
    if (this.data.fuente == "abmfuentes") {
      this.bofuenteSeleccionada = true;
      this.dominio = this.data.dominio;
    }
  }

  onNoClick(): void {
    const res = {
      status: false,
      value: null
    }
    this.dialogRef.close(res);
  }

  onEliminar(): void {
    let mensaje = ""
    let titulomensaje = ""
    if (this.data.bodominio) {
      titulomensaje = "¿ Está seguro que desea eliminar RDS ?"
    } else {
      titulomensaje = "¿ Está seguro que desea eliminar subDominio ?"
    }

    if (this.dominio == "") {
      this.notificationService.showError("¡ Debe ingresar Dominio !")
      return;
    }
    if (this.subdominio == "") {
      if (this.data.bodominio) {
        mensaje = "¡ Debe ingresar RDS a eliminar !"
      } else {
        mensaje = "¡ Debe ingresar subDominio a eliminar !"
      }
      this.notificationService.showError(mensaje)
      return;
    }
    this.confirmationDialogService
      .confirmAction(
        "Eliminar Información",
        titulomensaje
      )
      .then((confirmed) => {
        if (confirmed) {
          const res = {
            status: true,
            dominio: this.dominio,
            subdominio: this.subdominio,
            boelimina: true,
          }
          this.dialogRef.close(res);
        }
      });

  }

  onSubmit(): void {
    let mensaje = ""
    let titulomensaje = ""
    if (this.data.bodominio) {
      titulomensaje = "¿ Está seguro que desea agregar RDS ?"
    } else {
      titulomensaje = "¿ Está seguro que desea agregar subDominio ?"
    }

    if (this.dominio == "") {
      this.notificationService.showError("¡ Debe ingresar Dominio !")
      return;
    }
    if (this.subdominio == "") {
      if (this.data.bodominio) {
        mensaje = "¡ Debe ingresar RDS !"
      } else {
        mensaje = "¡ Debe ingresar subDominio(s) !"
      }
      this.notificationService.showError(mensaje)
      return;
    }
    this.confirmationDialogService
      .confirmAction(
        "Agregar Información",
        titulomensaje
      )
      .then((confirmed) => {
        if (confirmed) {
          const res = {
            status: true,
            dominio: this.dominio,
            subdominio: this.subdominio,
            boelimina: false,
          }
          this.dialogRef.close(res);
        }
      });
  }

  addValue(data) {
    console.log('data', data);
    this.btnStatus = (data === "");
  }

}
